import { isIOS } from 'react-device-detect'

import Alert from '@web/components/Modal/Alert'
import { useModal } from '@web/components/Modal/useModal'
import { useGoTo } from '@web/hooks/useGoTo'
import links from '@web/libs/constants/links'
import nClicks from '@web/libs/nlog/click/codes'

const useUpdateNaverAppModal = () => {
  const { goTo } = useGoTo()

  const { openModal } = useModal(Alert, {
    label: {
      confirm: '확인',
      cancel: '취소',
    },
    title: (
      <>
        선택하신 기능은 네이버앱
        <br />
        최신 버전에서 사용할 수 있어요.
      </>
    ),
    callback: {
      confirm: () => {
        const downloadLink = isIOS ? links.NAVER_APP_IOS_STORE : links.NAVER_APP_ANDROID_STORE
        goTo(downloadLink, { openWindow: true })
      },
    },
    clickCodes: {
      confirm: nClicks.checkin.UPDATE_POPUP_YES,
      cancel: nClicks.checkin.UPDATE_POPUP_NO,
    },
  })

  return { openModal }
}

export default useUpdateNaverAppModal
